/**
 * Home's reason line (#6559): who did what with a suggested document, and
 * when. A module of its own so the grammar is unit-tested without mounting
 * Home.
 */
import { formatInstant } from "@/utils/temporal";
import type { SuggestedDocument, SuggestionKind } from "./api";

/** The reason line, Drive's grammar in our voice: who did what, when.
 *
 *  Always a predicate about the viewer's own relationship to the row, never a
 *  name (Claude Design, round 7). A predicate is short by nature and fits the
 *  column; the moment a reason carries an arbitrary-length proper noun the
 *  column is being used to hold data, and a record's name belongs in Related
 *  to, where names are expected, linkable, and safe to truncate. */
const REASON_LABELS: Record<SuggestionKind, string> = {
  opened: "You opened",
  uploaded: "You uploaded",
  attached: "Attached to your chat",
  cited: "Cited in your chat",
};

export const reasonLabel = (
  reason: SuggestedDocument["reason"],
  zone: string
): string => {
  // Exhaustive over the kinds the client knows — adding one without a label is
  // a compile error — and total at runtime, because a backend one deploy behind
  // still sends the retired `linked` kind and a lookup that missed printed the
  // string "undefined ·" into the column. An unknown reason has nothing to say,
  // so it says nothing.
  const what = (REASON_LABELS as Record<string, string | undefined>)[
    reason.kind
  ];
  if (what === undefined) return "";
  return `${what} · ${formatInstant(reason.at, zone, "monthDay")}`;
};
